<div class="row text-center" style="margin-left: 10px">
<div *ngFor="let roommate of backendService.roommates"  style="margin-left: 1px; margin-right: 1px;">
  <div [classList]="roommateBgCalc(roommate)" style="border-radius: 5px 5px 5px 5px;  padding-left: 7px; padding-right: 7px" class="text-center text-white">
    <span class="whiteout">{{roommate.name.charAt(0)}}</span>
  </div>
</div>
</div>
